module.exports = "/_next/static/images/00145aee84bc700802242a8e93637b28-man-looking-up-smiling-md@2x.jpg";